import React from 'react';
import { unique } from 'underscore';

import { LocalPresets, LocalPresetsConfig } from './types';

interface UseLocalPresetsConfig {
  aspectRatio: number;
  extensionConfig?: LocalPresetsConfig;
}

type UseLocalPresets = LocalPresets;

const useLocalPresets = (config: UseLocalPresetsConfig): UseLocalPresets => {
  const { aspectRatio, extensionConfig = {} } = config;

  const formattedPresets = React.useMemo(
    () => (extensionConfig.presets ? unique(extensionConfig.presets) : []),
    [extensionConfig.presets],
  );

  if (!extensionConfig.enabled || !formattedPresets.length) {
    return {
      aspectRatio,
      enabled: false,
      presets: formattedPresets,
    };
  }

  return {
    aspectRatio,
    enabled: true,
    presets: formattedPresets,
  };
};

export default useLocalPresets;
